export const LOCALES = ['fr', 'en', 'de', 'fi', 'es', 'it', 'pt', 'nl']
